import styled from 'styled-components';

export const PlatformStyle = styled.div`
    min-height:100%;
    /* min-width:1920px; */
    width:100%;
    min-width:1250px;
    overflow:auto;

    background:rgba(245,246,250,1);

    .platform-kfpt{
        min-height:100%;
        background:rgba(245,246,250,1);

        .platform-header{
            display:flex;
            align-items:center;

            /* width:1920px; */
            width:100%;
            height:63px;

            background:rgba(255,255,255,1);

            .wrapper{
                display:flex;
                justify-content:space-between;

                max-width:1200px;
                width:80%;
                margin:0 auto;

                .platform-logo{
                    /* margin:0 667px 0 530px; */
                    width:138px;
                    height:39px;

                    cursor: pointer;
                }

                .platform-info{
                    display:flex;
                    align-items:center;

                    .icon{
                        width:43px;
                        height:43px;

                        border-radius:50%;
                        background:#ccc;
                    }

                    .nickname{
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;

                        max-width:140px;
                        margin:0 40px 0 20px;

                        font-size:14px;
                        font-weight:400;
                        color:rgba(102,102,102,1);
                        text-align:center;
                    }

                    .quit{
                        font-size:14px;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        cursor: pointer;
                    }

                    .quit:hover{
                        color:#28B6FF;
                    }
                }
            }
        }

        .platform-main{
            /* margin:44px 0 0 341px; */
            /* width:90%; */
            max-width:1200px;
            
            margin:44px auto 0;

            .wrapper{
                display:flex;
                justify-content:space-between;

                .ant-menu-item,
                .ant-menu-submenu-title{
                    /* height:67px!important; */
                    /* font-size:20px!important;
                    font-weight:500!important;
                    line-height:67px!important; */
                }

                .ant-menu-submenu-title{
                    padding-left:39px!important;
                }

                .ant-menu-item{
                    padding-left:39px!important;
                    font-size:16px!important;
                }

                /* .ant-menu-item-selected{
                    background:rgba(240,243,247,1)!important;
                    color:rgba(40,182,255,1)!important;
                } */

                .platform-item{
                    /* margin-left:26px; */
                    margin-bottom:47px;
                    width:1005px;
                    /* height:926px; */

                    background:rgba(255,255,255,1);
                    box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);
                    border-radius:14px;
                }
            }
        }
    }
`;

export const AlbumStyle = styled.div`
    height:100%;
    width:100%;

    .album-kfpt{
        display:flex;
        flex-direction:column;
        align-items:center;

        height:100%;
        padding:44px 25px 29px;

        border-radius: 14px;

        .album-header{
            display:flex;
            align-items:center;

            margin:0 0 60px;
            width:100%;

            .header-title{
                margin:0 20px 0 40px;

                font-size:18px;
                font-weight:500;
                color:rgba(102,102,102,1);
                font-weight:bold;
            }

            .create-ablum{
                display:flex;
                justify-content:center;
                align-items:center;

                width:113px;
                height:41px;
                margin-left:340px;

                background:rgba(40,182,255,1);
                box-shadow:0px 2px 4px 0px rgba(40,182,255,0.53);
                border-radius:21px;
                font-size:14px;
                font-weight:500;
                color:rgba(255,255,255,1);
                cursor: pointer;
            }

            .create-ablum:hover{
                background:#00A3F7;
            }
        }

        .album-main{
            overflow:hidden;

            width:100%;

            background:rgba(248,249,251,1);
            border-radius:14px;
            border:1px solid rgba(240,240,241,1);

            .tabs{
                display:flex;
                align-items:center;

                height:67px;
                
                >div{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    height:100%;
                }
            }

            .album-list{
                display:flex;
                flex-direction:column;
                align-items:center;

                width:100%;
                /* height:684px; */
                /* background:#ccc; */

                .album-item{
                    display:flex;
                    align-items:center;

                    height:114px;
                    width:100%;

                    .item{
                        display:flex;
                        justify-content:center;
                        align-items:center;

                        height:100%;
                    }

                    .eeee:hover{
                        color:#28B6FF;
                    }
                }

                .program-empty{
                    display:flex;
                    flex-direction:column;
                    justify-content:center;
                    align-items:center;

                    width:956px;
                    height:685px;

                    background:rgba(252,253,255,1);
                    border-radius:0px 0px 14px 14px;

                    .empty{
                        width:132px;
                        height:140px;
                        margin-bottom:20px;
                    }

                    .text{
                        font-size:14px;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                    }
                }
            }
        }
    }

    .mask{
        position: fixed;
        top:0;
        left:0;
        overflow:auto;

        width:100%;
        height:100%;

        background:rgba(53,53,53,0.21);
        box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);

        .mask-con{
            display:flex;
            flex-direction:column;

            margin:100px auto;
            width:752px;
            height:655px;

            background:rgba(255,255,255,1);
            box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);
            border-radius:14px;

            .mask-title{
                margin:38px auto 49px;

                font-size:24px;
                font-weight:500;
                color:rgba(51,51,51,1);
            }

            .mask-name{
                display:flex;
                align-items:center;

                padding-left:80px;

                .t2{
                    margin:0 7px 0 66px;
                    width:410px;
                    height:36px;
                    padding:0 15px;

                    background:rgba(216,216,216,.19);
                    border-radius:6px;
                    border:1px solid rgba(151,151,151,.19);
                    outline:0;
                }

                >span{
                    font-size:18px;
                    font-weight:400;
                    color:rgba(224,32,32,1);
                }
            }

            .mask-intro{
                display:flex;

                padding-left:80px;
                margin:25px 0;

                .t4{
                    width:410px;
                    height:74px;
                    margin-left:66px;
                    padding:10px 15px;
                    
                    background:rgba(216,216,216,.19);
                    border-radius:6px;
                    border:1px solid rgba(151,151,151,.19);
                    outline:0;
                    resize:none;
                }
            }
            
            .mask-cover{
                display:flex;

                padding-left:80px;

                .ant-upload.ant-upload-select-picture-card{
                    border:1px solid rgba(151,151,151,.19);
                    border-radius:6px;
                }
                
                .avatar-uploader{
                    margin-left:66px;
                    width:auto;
                }
            }

            .mask-tip{
                margin-left:218px;
                width:410px;

                font-size:12px;
                font-weight:400;
                color:rgba(153,153,153,1);
            }

            .mask-release{
                display:flex;

                padding-left:80px;
                margin:25px 0;

                .ant-select{
                    margin-left:66px;
                }
            }

            .mask-audit{
                display:flex;

                padding-left:80px;

                .ant-select{
                    margin-left:66px;
                }
            }

            .mask-btns{
                display:flex;
                align-items:center;
                
                padding-left:218px;

                .btn1{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    width:104px;
                    height:45px;

                    background:rgba(40,182,255,1);
                    box-shadow:0px 2px 4px 0px rgba(40,182,255,0.53);
                    border-radius:9px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .btn1:hover{
                   background:#00A3F7; 
                }

                .btn2{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    width:104px;
                    height:45px;
                    margin-left:40px;

                    background:rgba(0,0,0,0.15);
                    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1);
                    border-radius:6px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .btn2:hover{
                    background:rgba(0,0,0,0.2);
                }
            }

            .mask-lab{
                font-size:18px;
                font-weight:bold;
                color:rgba(102,102,102,1);
            }
        }
    }

    .firstmask{
        position: fixed;
        top:0;
        left:0;

        width:100%;
        height:100%;

        background:rgba(53,53,53,0.21);
        box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);

        .firstmask-con{
            display:flex;
            flex-direction:column;
            align-items:center;

            margin:300px auto;
            width:350px;
            height:227px;

            background:rgba(255,255,255,1);
            box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);
            border-radius:14px;

            .firstmask-img{
                margin-top:-64px;
                width:81px;
                height:81px;
            }

            .firstmask-title{
                margin:12px 0 28px;

                font-size:20px;
                font-weight:500;
                color:rgba(51,51,51,1);
            }

            .firstmask-text1{
                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
            }

            .firstmask-text2{
                display:flex;
                align-items:center;
                justify-content:center;

                margin:0 0 40px;

                .firstmask-agree{
                    width:12px;
                    height:12px;
                    margin-right:5px;
                    
                    border-radius:50%;
                    border:1px solid #999;
                    cursor: pointer;
                }


                .firstmask-text3{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(51,51,51,1);

                    >span{
                        text-decoration:underline;
                        cursor: pointer;
                    }
                }
            }

            .firstmask-btns{
                display:flex;
                align-items:center;

                .firstmask-btn1{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    width:130px;
                    height:45px;

                    background:rgba(0,0,0,0.15);
                    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1);
                    border-radius:6px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .firstmask-btn2:hover{
                    background:#00A3F7;
                }

                .firstmask-btn2{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    width:130px;
                    height:45px;
                    margin-left:30px;

                    background:rgba(40,182,255,1);
                    box-shadow:0px 2px 4px 0px rgba(40,182,255,0.53);
                    border-radius:9px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .firstmask-btn1:hover{
                    background:rgba(0,0,0,0.2);
                }
            }
        }
    }
`;

export const InformationStyle = styled.div`
    height:100%;
    width:100%;

    .information-kfpt{
        display:flex;
        flex-direction:column;
        
        padding:49px 0 0 87px;

        .info-title{
            font-size:24px;
            font-weight:bold;
            color:rgba(102,102,102,1);
        }

        .info-t1{
            font-size:16px;
            font-weight:500;
            color:rgba(102,102,102,1);
        }

        .info-icon{
            display:flex;

            margin-top:49px;

            .ant-upload.ant-upload-select-picture-card{
                border:1px solid rgba(151,151,151,.19);
                border-radius:6px;
            }

            .avatar-uploader{
                width:auto;
                margin-left:52px;
            }

            .info-icon1{
               width:100%;
            }
        }

        .info-account{
            display:flex;

            margin:25px 0;

            .info-phone{
                padding:0 15px;
                margin-left:52px;
                width:588px;
                height:36px;

                background:rgba(216,216,216,0.19);
                border-radius:6px;
                border:1px solid rgba(151,151,151,0.19);
                outline:0;
            }
        }

        .info-nick{
            display:flex;

            .info-nickname{
                padding:0 15px;
                margin-left:84px;
                width:588px;
                height:36px;

                background:rgba(216,216,216,0.19);
                border-radius:6px;
                border:1px solid rgba(151,151,151,0.19);
                outline:0;
            }
        }

        .info-sex{
            display:flex;

            margin:25px 0;

            .ant-radio-group{
                margin-left:101px;
            }
        }

        .info-intro{
            display:flex;

            .info-text{
                width:588px;
                height:117px;
                margin-left:84px;
                padding:10px 15px;
                
                background:rgba(216,216,216,.19);
                border-radius:6px;
                border:1px solid rgba(151,151,151,.19);
                outline:0;
                resize:none;
            }
        }

        .info-btns{
            display:flex;

            margin:50px 0 307px 116px;

            .info-btn1{
                display:flex;
                justify-content:center;
                align-items:center;

                width:104px;
                height:45px;
                margin-right:40px;

                background:rgba(40,182,255,1);
                box-shadow:0px 2px 4px 0px rgba(40,182,255,0.53);
                border-radius:9px;
                font-size:16px;
                font-weight:500;
                color:rgba(255,255,255,1);
                cursor: pointer;
            }

            .info-btn1:hover{
                background:#00A3F7;
            }

            .info-btn2{ 
                display:flex;
                justify-content:center;
                align-items:center;

                width:104px;
                height:45px;

                background:rgba(0,0,0,0.15);
                box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1);
                border-radius:6px;
                font-size:16px;
                font-weight:500;
                color:rgba(255,255,255,1);
                cursor: pointer;
            }

            .info-btn2:hover{
                background:rgba(0,0,0,0.2)
            }
        }
    }

`;

export const ProgramStyle = styled.div`
    width:100%;
    height:100%;

    .program-kfpt{
        display:flex;
        flex-direction:column;
        align-items:center;

        height:100%;
        padding:44px 25px 29px;

        border-radius: 14px;

        .program-header{
            display:flex;
            flex-direction:column;

            padding-left:15px;
            width:100%;

            .header-line{
                display:flex;
                align-items:center;

                margin-bottom:22px;
                width:100%;

                .header-title{
                    font-size:18px;
                    font-weight:500;
                    color:rgba(102,102,102,1);
                    font-weight:bold;
                }

                .ant-select{
                    margin:0 35px;
                }

                .create-program{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    margin-left:230px;
                    width:113px;
                    height:41px;

                    background:rgba(40,182,255,1);
                    box-shadow:0px 2px 4px 0px rgba(40,182,255,0.53);
                    border-radius:21px;
                    font-size:14px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .create-program:hover{
                    background:#00A3F7;
                }
            }
        }

        .program-main{
            width:100%;

            background:rgba(248,249,251,1);
            border-radius:14px;
            border:1px solid rgba(240,240,241,1);


            .main-tabs{
                display:flex;
                align-items:center;

                height:67px;
                
                >div{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    height:100%;
                }

            }

            .program-list{
                overflow:hidden;
                display:flex;
                flex-direction:column;
                align-items:center;

                width:100%;

                border-radius:0px 0px 14px 14px;

                .program-item{
                    display:flex;
                    align-items:center;

                    height:114px;
                    width:100%;

                    .item{
                        display:flex;
                        justify-content:center;
                        align-items:center;

                        height:100%;
                    }

                    .eeee:hover{
                        color:#28B6FF;
                    }
                }
            }

            .program-empty{
                display:flex;
                flex-direction:column;
                justify-content:center;
                align-items:center;

                width:100%;
                height:685px;

                background:rgba(252,253,255,1);
                border-radius:0px 0px 14px 14px;

                .empty{
                    width:132px;
                    height:140px;
                    margin-bottom:20px;
                }

                .text{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                }
            }
        }
    }

    .firstadd{
        position: fixed;
        top:0;
        left:0;

        width:100%;
        height:100%;

        background:rgba(53,53,53,0.21);
        box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);

        .firstadd-con{
            display:flex;
            flex-direction:column;
            align-items:center;

            margin:200px auto;
            width:350px;
            height:230px;

            background:rgba(255,255,255,1);
            box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);
            border-radius:14px;

            .firstadd-img{
                width:81px;
                height:81px;
                margin-top:-64px;
            }

            .firstadd-title{
                display:flex;
                justify-content:center;
                align-items:center;

                margin:12px 0 30px;

                font-size:20px;
                font-weight:500;
                color:rgba(51,51,51,1);
            }

            .firstadd-text{
                display:flex;
                justify-content:center;
                align-items:center;

                font-size:14px;
                font-weight:400;
                color:rgba(51,51,51,1);
            }

            .firstadd-btns{
                display:flex;
                justify-content:center;
                align-items:center;

                margin-top:51px;


                .firstadd-btn1{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    width:130px;
                    height:45px;
                    margin-right:30px;

                    background:rgba(0,0,0,0.15);
                    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1);
                    border-radius:6px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .firstadd-btn2:hover{
                    background:#00A3F7;
                }

                .firstadd-btn2{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    width:130px;
                    height:45px;

                    background:rgba(40,182,255,1);
                    box-shadow:0px 2px 4px 0px rgba(40,182,255,0.53);
                    border-radius:9px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .firstadd-btn1:hover{
                    background:rgba(0,0,0,.2)
                }
            }
        }
    }

    .mask{
        position: fixed;
        top:0;
        left:0;
        overflow: auto;

        width:100%;
        height:100%;

        background:rgba(53,53,53,0.21);
        box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);

        .mask-con{
            display:flex;
            flex-direction:column;

            margin:100px auto;
            width:752px;
            /* height:700px; */
            padding-left:80px;

            background:rgba(255,255,255,1);
            box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);
            border-radius:14px;
            
            .mask-title{
                margin:30px 0 20px 256px;

                font-size:24px;
                font-weight:500;
                color:rgba(51,51,51,1);
            }

            .mask-ablum{
                display:flex;
                align-items:center;

                .ant-select{
                    margin-left:66px;
                    width:410px!important;
                }

                .ant-select-selector{
                    background:rgba(216,216,216,.19);
                    padding:0 15px!important;
                }

                >span{
                    margin-left:10px;

                    font-size:18px;
                    font-weight:400;
                    color:rgba(224,32,32,1);
                }
            }

            .mask-word{
                font-size:18px;
                font-weight:bold;
                color:rgba(102,102,102,1);
            }

            .mask-name{
                display:flex;
                align-items:center;

                margin:25px 0;

                .mask-pro{
                    margin:0 0 0 66px;
                    width:410px;
                    height:36px;
                    padding:0 15px;

                    background:rgba(216,216,216,.19);
                    border-radius:6px;
                    border:1px solid rgba(151,151,151,.19);
                    outline:0;
                }

                >span{
                    margin-left:10px;

                    font-size:18px;
                    font-weight:400;
                    color:rgba(224,32,32,1);
                }
            }

            .mask-intro{
                display:flex;

                .mask-area{
                    width:410px;
                    height:74px;
                    margin-left:66px;
                    padding:10px 15px;
                    
                    background:rgba(216,216,216,.19);
                    border-radius:6px;
                    border:1px solid rgba(151,151,151,.19);
                    outline:0;
                    resize:none;
                }

            }

            .mask-detail{
                display:flex;
                align-items:center;

                margin: 10px 0 5px 138px;

                font-size:12px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(153,153,153,1);
            }

            .mask-audio{
                position: relative;
                display:flex;
                /* align-items:center; */

                margin:25px 0 0;

                .audio-control{
                    position: absolute;
                    left:259px;
                    top:6px;

                    width:22px;
                    height:22px;

                    cursor: pointer;
                }

                #audio_file{
                    position: absolute;
                    left:138px;
                    top:0;

                    width:160px;
                    height:36px;
                    
                    opacity:0;
                    cursor: pointer;
                }
                .ant-upload-list-item-info{
                    padding:10px;
                    background-color:#f5f5f5;

                    .anticon{
                        top:15px;
                    }
                }

               .ant-upload-list-item-progress{
                   bottom:-16px;
               }

                .ant-upload-select-text,.ant-upload-list-text{
                    width:410px;
                    margin-left:66px;
                }

                .ant-upload-list-item{
                    height:auto;
                }

                .ant-upload-list-item-name{
                    overflow:visible;
                    white-space:normal;
                    text-overflow:clip;
                }

                .upaudio{
                    display:flex;
                    align-items:center;
                    justify-content:center;

                    width:160px;
                    height:36px;
                    margin-left:66px;

                    background:rgba(68,215,182,1);
                    border-radius:6px;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .upaudio-done{
                    display:flex;
                    align-items:center;
                    justify-content:center;

                    /* width:240px; */
                    height:36px;
                    margin-left:66px;
                    padding:0 18px;

                    background:rgba(68,215,182,1);
                    border-radius:6px;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .iii{
                    /* margin-left:10px; */
                    position: absolute;
                    left:259px;
                    top:3px;

                    font-size:18px;
                    font-weight:400;
                    color:rgba(224,32,32,1);
                }
            }

            .limit{
                margin-left:138px;
                width:410px;
                margin-top:10px;

                font-size:12px;
                font-weight:400;
                color:rgba(153,153,153,1);
            }

            .mask-cover{
                display:flex;

                margin:25px 0 0;
                
                .ant-upload.ant-upload-select-picture-card{
                    border:1px solid rgba(151,151,151,.19);
                    border-radius:6px;
                }
                
                .avatar-uploader{
                    margin-left:66px;
                    width:auto;
                }
            }

            .mask-tip{
                margin-left:137px;
                width:410px;

                font-size:12px;
                font-weight:400;
                color:rgba(153,153,153,1);
            }

            .mask-release{
                display:flex;

                margin:25px 0 0;

                .ant-select{
                    margin-left:102px;
                }
            }

            
            .status-tip{
                padding-left:138px;
                margin:5px 0 10px;

                font-size:12px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(255,77,77,1);
            }

            .mask-btns{
                display:flex;
                align-items:center;
                
                padding-left:134px;
                margin-bottom:25px;

                .btn1{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    width:104px;
                    height:45px;

                    background:rgba(40,182,255,1);
                    box-shadow:0px 2px 4px 0px rgba(40,182,255,0.53);
                    border-radius:9px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .btn1:hover{
                    background:#00A3F7;
                }

                .btn2{
                    display:flex;
                    justify-content:center;
                    align-items:center;

                    width:104px;
                    height:45px;
                    margin-left:40px;

                    background:rgba(0,0,0,0.15);
                    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.1);
                    border-radius:6px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                }

                .btn2:hover{
                    background:rgba(0,0,0,0.2);
                }
            }
        }
    }
`;